import React from 'react';

export enum QuoteFormErrorMessages {
  MAX_BUY = `MAX_BUY`,
}

interface QuoteFormBuyingErrorMessageProps {
  error: string;
}
const QuoteFormBuyingErrorMessage: React.FC<
  QuoteFormBuyingErrorMessageProps
> = ({ error }) => {
  switch (error) {
    case QuoteFormErrorMessages.MAX_BUY:
      return (
        <span className="text-text/body-primary">
          If you're looking to buy a property over £2m, please get in touch with
          our Move Specialists on{' '}
          <a className="underline" href="tel:03332344425">
            0333 234 4425
          </a>{' '}
          for a bespoke conveyancing quote.
        </span>
      );
      break;
  }
  return <span className="text-text/body-primary">{error}</span>;
};

export default QuoteFormBuyingErrorMessage;
